export const ENFORCE_FIELD_LEVEL_PERMISSIONS = 'Automation:EnforceFieldLevelPermissions';